<div class="comecar" [class.comecar--largo]="passo === 'cardapio'" [class.comecar--hub]="!passo">
  <div class="cm-aviso" *ngIf="carregando">Carregando…</div>

  <div class="cm-aviso cm-aviso--erro" *ngIf="!carregando && erro">
    {{ erro }} <button type="button" class="cm-link" (click)="carregue()">Tentar de novo</button>
  </div>

  <ng-container *ngIf="!carregando && !erro && estado">

    <!-- tela Pronto -->
    <app-tela-pronto *ngIf="passo === 'pronto'" [estado]="estado" [empresa]="empresa"></app-tela-pronto>

    <div class="cm-aviso" *ngIf="!estado.ativo && passo !== 'pronto'">
      Sua loja já passou pelos primeiros passos. <a class="cm-link" routerLink="/admin/index">Ir para o início</a>
    </div>

    <!-- antes dos passos, uma vez: tipo de comida e faturamento -->
    <app-onb-perfil *ngIf="estado.ativo && estado.perfil && !estado.perfil.respondido && passo !== 'pronto'" [estado]="estado"
                    (concluido)="atualize($event)"></app-onb-perfil>

    <ng-container *ngIf="estado.ativo && (!estado.perfil || estado.perfil.respondido)">
      <!-- um passo (o prêmio aparece no cabeçalho de cada um, pela moldura) -->
      <ng-container [ngSwitch]="passo" *ngIf="passo && passo !== 'pronto'">
        <app-passo-cardapio *ngSwitchCase="'cardapio'" [estado]="estado" (concluido)="aoConcluirPasso()" (ajuda)="pecaAjudaDe($event)"></app-passo-cardapio>
        <app-passo-loja *ngSwitchCase="'loja'" [estado]="estado" (concluido)="aoConcluirPasso($event)"></app-passo-loja>
        <app-passo-pagamento *ngSwitchCase="'pagamento'" [estado]="estado" (concluido)="aoConcluirPasso($event)"></app-passo-pagamento>
        <app-passo-receber *ngSwitchCase="'receber'" [estado]="estado" (concluido)="aoConcluirPasso($event)"
                           (atualizou)="atualize($event)" (ajuda)="pecaAjudaDe($event)"></app-passo-receber>
        <app-passo-teste *ngSwitchCase="'teste'" [estado]="estado" (concluido)="aoConcluirTeste($event)" (atualizou)="atualize($event)"></app-passo-teste>
      </ng-container>

      <!-- hub -->
      <ng-container *ngIf="!passo">
        <div class="cm-layout">
          <main class="cm-principal">
            <header class="cm-titulo">
              <h1>Primeiros passos</h1>
              <p class="cm-sub">{{ faltam ? 'Siga as etapas abaixo para abrir sua loja e começar a receber pedidos.' : 'Tudo pronto para receber seu primeiro pedido.' }}</p>
              <p class="cm-sub cm-sub--menu" *ngIf="!empresa?.onboarding?.menuCompleto">Enquanto você monta a loja, o menu mostra só o essencial. Estoque, equipe, relatórios e o resto estão em <b>Quero ver logo todas as funções</b>, no fim do menu, e vão entrando sozinhos conforme a loja anda.</p>
            </header>

            <section class="cm-cabecalho" aria-label="Seu progresso">
              <div class="cm-resumo">
                <div>
                  <div class="cm-contagem"><strong>{{ estado.feitos }} de {{ estado.total }}</strong><span>etapas concluídas</span></div>
                  <p class="cm-tempo" *ngIf="faltam"><i class="far fa-clock" aria-hidden="true"></i> Tempo estimado restante: <b>{{ textoTempo }}</b></p>
                </div>
                <app-onb-bonus [estado]="estado" formato="cartao"></app-onb-bonus>
              </div>
              <div class="cm-meta"><span>Progresso geral</span><strong>{{ percentual }}%</strong></div>
              <div class="cm-progresso" role="progressbar" aria-label="Primeiros passos" aria-valuemin="0"
                   [attr.aria-valuemax]="estado.total" [attr.aria-valuenow]="estado.feitos">
                <i *ngFor="let p of estado.passos" [class.feito]="p.feito"></i>
              </div>
            </section>

            <div class="cm-etapas-titulo"><h2>Seu checklist de lançamento</h2><span>Clique para avançar em cada etapa</span></div>
            <div class="cm-etapas">
              <button type="button" class="cm-linha" *ngFor="let p of estado.passos" [class.proximo]="ehProximo(p)"
                      [attr.aria-current]="ehProximo(p) ? 'step' : null" (click)="abra(p)">
                <span class="onb-ic onb-ic--{{ p.id }}" [class.onb-ic--ok]="p.feito"><i [class]="icone(p)" aria-hidden="true"></i></span>
                <span class="cm-etapa-texto">
                  <span class="cm-recomendado" *ngIf="ehProximo(p)">Próximo passo · {{ estado.feitos ? 'Continue por aqui' : 'Comece por aqui' }}</span>
                  <b>{{ p.nome }}</b><span class="cm-detalhe">{{ p.detalhe }}</span>
                </span>
                <span class="onb-pill onb-pill--ok" *ngIf="p.feito">Feito</span>
                <span class="cm-comecar" *ngIf="ehProximo(p)">{{ p.iniciado ? 'Continuar' : 'Começar' }} <i class="fas fa-arrow-right" aria-hidden="true"></i></span>
                <span class="cm-seta" *ngIf="!ehProximo(p)"><i class="fas fa-chevron-right" aria-hidden="true"></i></span>
              </button>
            </div>

            <section class="cm-ajuda">
              <span class="cm-ajuda-icone"><i class="fas fa-comment" aria-hidden="true"></i></span>
              <div><h2>Quer ajuda para montar a sua loja?</h2><p>Conte com nosso time para configurar seus itens e preparar sua operação.</p></div>
              <button type="button" (click)="pecaAjudaDe({motivo: 'Preciso de ajuda para montar minha loja', passo: 'comecar'})">Falar com a equipe <i class="fas fa-arrow-right" aria-hidden="true"></i></button>
            </section>
          </main>

          <aside class="cm-previa" aria-label="Meu Cardápio">
            <section class="cm-acesso">
              <div class="cm-acesso-titulo"><h2><span></span> Meu Cardápio</h2><span class="cm-previa-selo">Prévia da sua loja</span></div>
              <div class="cm-url" *ngIf="empresa?.linkLoja; else semLink">
                <i class="fas fa-globe" aria-hidden="true"></i><span>{{ linkCurto }}</span>
                <button type="button" (click)="copieLink()">{{ copiado ? 'Copiado!' : 'Copiar' }}</button>
                <a [href]="empresa.linkLoja" target="_blank" rel="noopener" aria-label="Acessar meu cardápio (abre em nova aba)"><i class="fas fa-external-link-alt" aria-hidden="true"></i></a>
              </div>
              <ng-template #semLink><p class="cm-sub">O endereço do seu cardápio aparecerá aqui.</p></ng-template>
              <p class="cm-copia-erro" role="status" *ngIf="erroCopia">{{ erroCopia }}</p>
            </section>

            <div class="cm-celular">
              <div class="cm-tela">
                <!-- loja sem cardápio: em vez da página vazia, o topo da loja e as portas do passo Cardápio -->
                <div class="cm-vazia" *ngIf="!cardapioPronto; else lojaReal">
                  <button type="button" class="cm-vazia-logo" (click)="abra('loja')" [title]="empresa?.logo ? 'Trocar o logo' : 'Adicionar o logo'">
                    <img *ngIf="empresa?.logo" [src]="'/images/empresa/' + empresa.logo" [alt]="'Logo de ' + (empresa?.nome || 'sua loja')">
                    <i *ngIf="!empresa?.logo" class="fas fa-camera" aria-hidden="true"></i>
                  </button>
                  <b class="cm-vazia-nome">{{ empresa?.nome || 'Sua loja' }}</b>
                  <span class="cm-vazia-sub">{{ cardapioIniciado ? 'Seus produtos chegaram. Revise os preços para eles aparecerem aqui.' : 'Seu cardápio ainda está vazio. Como você quer trazer os produtos?' }}</span>
                  <ng-container *ngIf="!cardapioIniciado; else continuarCardapio">
                    <button type="button" class="cm-vazia-opcao cm-vazia-opcao--pri" (click)="abraCardapio('foto')">
                      <i class="fas fa-file-alt" aria-hidden="true"></i><span><b>Foto ou PDF</b><small>A IA monta o cardápio</small></span>
                    </button>
                    <div class="cm-vazia-extras">
                      <button type="button" (click)="abraCardapio('texto')"><i class="fas fa-clipboard" aria-hidden="true"></i> Colar texto</button>
                      <button type="button" (click)="abraCardapio('planilha')"><i class="fas fa-file-csv" aria-hidden="true"></i> Planilha CSV</button>
                    </div>
                    <button type="button" class="cm-vazia-opcao" (click)="abraCardapio('ifood')">
                      <img src="/assets/icons/logo-ifood.png" alt=""><span><b>Trazer do iFood</b><small>Cole o link da sua loja</small></span>
                    </button>
                    <button type="button" class="cm-vazia-opcao cm-vazia-opcao--sistema" (click)="abraCardapio('sistema')">
                      <i class="fas fa-exchange-alt" aria-hidden="true"></i><span><b>Tenho outro sistema</b><small>Anota AI, Goomer, OlaClick…</small></span>
                    </button>
                    <button type="button" class="cm-vazia-mao" (click)="abraCardapio('manual')">Cadastrar na mão</button>
                  </ng-container>
                  <ng-template #continuarCardapio>
                    <button type="button" class="cm-vazia-opcao cm-vazia-opcao--pri" (click)="abraCardapio()">
                      <i class="fas fa-tags" aria-hidden="true"></i><span><b>Revisar preços</b><small>Produto sem preço não aparece na loja</small></span>
                    </button>
                  </ng-template>
                </div>
                <ng-template #lojaReal>
                  <iframe *ngIf="urlPrevia; else previaIndisponivel" class="cm-cardapio-frame" [src]="urlPrevia"
                          title="Meu Cardápio — loja real" loading="lazy"></iframe>
                  <ng-template #previaIndisponivel>
                    <p class="cm-preview-aviso">A prévia aparecerá quando o endereço do cardápio estiver disponível.</p>
                  </ng-template>
                </ng-template>
                <div class="cm-tela-rodape"><a *ngIf="empresa?.linkLoja" [href]="empresa.linkLoja" target="_blank" rel="noopener">Acessar meu cardápio <i class="fas fa-arrow-right" aria-hidden="true"></i></a></div>
              </div>
            </div>
            <p class="cm-legenda">{{ cardapioPronto ? 'Seu cardápio real: navegue para ver como seus clientes fazem pedidos.' : 'Com o cardápio pronto, seus produtos aparecem aqui como o cliente vê.' }}</p>
          </aside>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>

  <app-onb-ajuda [passo]="passo || 'comecar'" [telefoneGestor]="estado?.telefoneGestor" [empresa]="empresa"></app-onb-ajuda>
</div>
